import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

const itemBox = props => {
  const { title, description, icon, isSelected, onClick, children } = props;

  return (
    <div
      className={classnames({
        'item-box': true,
        'selected': isSelected === true,
        'clickable': typeof onClick === 'function'
      })}
      onClick={onClick}
    >
      {isSelected && <i className="os-icon os-icon-check-circle select-icon" />}
      <div className="box">
        {icon.length > 2 && <img src={icon} className="icon" alt={title} />}
        <div className="title"> {title} </div>
        <div className="description"> {description}</div>
        {children && <div className="addon">{children}</div>}
      </div>
    </div>
  );
};

itemBox.defaultProps = {
  icon: '',
  description: '',
  isSelected: false,
};

itemBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};

export default itemBox;
